import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker' 
import logout from '../../Global/logout' 

export default async function PutProvider(data, coutnries) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }

    let listofCountries = []
    coutnries.map(data => {
        return listofCountries.push(data.value)
    })

    let countryUuid =data.countries[0].country_uuid

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/' + data.uuid, {
            method: 'PUT',
            headers: { 'Authorization' : unHashedJwt},
            data: {
                "full_name": data.full_name.trim(),
                "email": data.email.trim(),
                "phone_number": data.phone_number.trim(),
                "business_countries": listofCountries,
                "company_country_uuid": countryUuid,
                "company_address": data.company_address.trim(),
                "premisess_label": data.premisess_label,
                "terminal_label": data.terminal_label,
                "sequence_marker": "P",
                "company_place": data.company_place,
                "company_postal_code": data.company_postal_code,
                "company_legal_ID": data.company_legal_id
            }      
        }).then(
            res => (res)
        ).catch(error => error.response.data)
    )
}